import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import Infomation from '../../../components/employees/create/infomation'
import CurrentAddress from '../../../components/employees/create/address'
import { Controller, useForm } from 'react-hook-form'
import { getRecruitsDetailsAPI } from '../../../services/recruit'
import Error_500 from '../../../components/error/error-500'
import moment from 'moment'
import NavRoleOrg from '../../../components/nav-role-org'
import { PIM_EMP } from '../../../router/routes'
import BtnBack from '../../../components/btn-back'
import { createEmpsAPI } from '../../../services/employee'
import { Link, useNavigate, useOutletContext } from 'react-router-dom'
import Error_false from '../../../components/error/error-false'
import { useSelector } from 'react-redux'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import Emergency from '../../../components/employees/create/emergency'
import NavTitle from '../../../components/nav-title'
import SwalCustom from '../../../alert/swal-custom'
import CardCustom from '../../../components/custom/card-custom'
import PersonalInformation from '../../../components/employees/create/histrory'
import UseAllOrganization from '../../../hooks/use-org-all'
import InputAutocompleteAE from '../../../helper/InputAutocompleteAE'
import IncomeFrom from '../../../components/employees/create/income'
import { FaAnglesRight } from 'react-icons/fa6'
import TextNavTitle from '../../../components/TextNavTitle'
import { usIsPassProbationStore } from '../../../store/pim'
import { useOrgSeleteStore } from '../../../store/layout'
import { HiOutlineShieldCheck } from 'react-icons/hi'

function PimCreate() {
  const { isPassProbation, setIsPassProbation } = usIsPassProbationStore()
  const [errorYup, setErrorYup] = useState()

  const schema = yup.object(errorYup).required()
  const {
    reset,
    control,
    setValue,
    setError,
    getValues,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })

  const { orgSelete } = useOrgSeleteStore()

  useEffect(() => {
    const _error = {
      empProbations: yup.object().required('กรุณาระบุสถานะทดลองงาน'),
      empsTypes: yup.object().required('กรุณาระบุประเภทพนักงาน'),
      startDate: yup.string().required('กรุณาระบุวันที่เริ่มงาน'),
      title_th: yup.object().required('กรุณาระบุคำนำหน้า'),
      name_th: yup.string().required('กรุณาระบุชื่อภาษาไทย'),
      surname_th: yup.string().required('กรุณาระบุนามสกุล'),
      nickname_th: yup.string().required('กรุณาระบุชื่อเล่น'),
      title_en: yup.object().required('กรุณาระบุคำนำหน้าภาษาอังกฤษ'),
      name_en: yup.string().required('กรุณาระบุชื่อภาษาอังกฤษ'),
      surname_en: yup.string().required('กรุณาระบุนามสกุลภาษาอังกฤษ'),
      nickname_en: yup.string().required('กรุณาระบุชื่อเล่นภาษาอังกฤษ'),
      divisions: yup.object().required('กรุณาระบุสายงาน'),
      department: yup.object().required('กรุณาระบุแผนก'),
      faction: yup.object().required('กรุณาระบุฝ่าย'),
      team: yup.object().required('กรุณาระบุทีม'),
      position: yup.object().required('กรุณาระบุตำแหน่ง'),
      level_id: yup.string().required('กรุณาระบุเลเวล'),
      reportby: yup.object().required('กรุณาระบุผู้บังคับบัญชา'),
      payment: yup.object().required('กรุณาระบุประเภทการจ่ายเงิน'),
      bank: yup.object().required('กรุณาระบุบัญชีธนาคาร'),
      codeBank: yup.string().required('กรุณาระบุเลขบัญชี'),
      shift: yup.object().required('กรุณาระบุตารางกะ'),
      travel: yup.object().required('กรุณาระบุการเดินทาง'),
      birthday: yup.string().required('กรุณาระบุวันเกิด'),
      sex: yup.object().required('กรุณาระบุเพศ'),
      nationality: yup.object().required('กรุณาระบุสัญชาติ'),
      id_card: yup.string().required('กรุณาระบุข้อมูล'),
      height: yup.number().positive().integer().required('กรุณาระบุส่วนสูง'),
      weight: yup.number().positive().integer().required('กรุณาระบุน้ำหนัก'),
      mobile: yup.string().required('กรุณาระบุเบอร์มือถือ'),
      phone: yup.object().required('กรุณาระบุค่าโทรศัพท์'),
      address_first: yup.string().required('กรุณาระบุที่อยู่ตามทะเบียนบ้าน'),
      province_first: yup.object().required('กรุณาระบุจังหวัด'),
      district_first: yup.object().required('กรุณาระบุเขต / อำเภอ'),
      sub_district_first: yup.object().required('กรุณาระบุแขวง / ตำบล '),
      post_code_first: yup.string().required('กรุณาระบุรหัสไปรษณีย์'),
      address: yup.string().required('กรุณาระบุที่อยู่ปัจจุบัน'),
      province: yup.object().required('กรุณาระบุจังหวัด'),
      district: yup.object().required('กรุณาระบุเขต / อำเภอ'),
      sub_district: yup.object().required('กรุณาระบุแขวง / ตำบล '),
      cr_post_code: yup.string().required('กรุณาระบุรหัสไปรษณีย์'),
      otFlatRate: yup.object().required('กรุณาระบุ OT เหมาจ่าย'),
      otShift: yup.object().required('กรุณาระบุ OT วันทำงานปกติ'),
      languageFee: yup.object().required('กรุณาระบุค่าภาษา'),
      experienceFee: yup.object().required('กรุณาระบุค่าประสบการณ์'),
      shiftFlatRate: yup.object().required('กรุณาระบุค่ากะเหมาจ่าย'),
      paymentGroup: yup.object().required('กรุณาระบุกลุ่มรายได้'),
      ...(isPassProbation && {
        employDate: yup.string().required('กรุณาระบุวันที่บรรจุงาน')
      }),
      ...(!orgSelete?.isCodeAuto && {
        code: yup.string().min(5).required('กรุณาระบุรหัสพนักงาน')
      })
    }

    setErrorYup(_error)
  }, [orgSelete, isPassProbation])

  const optionOrg = UseAllOrganization()
  const [orgShort, setOrgShort] = useState('')
  const [recruitsDetail, setRecruitsDetail] = useState()
  const [isSave, setIsSave] = useState(false)
  const [idPassport, setIdPassport] = useState(1)
  const navigate = useNavigate()
  const roleId = useSelector((state) => state.roleReducer.role)

  const onSubmit = (data) => {
    const d = data
    const body = {
      // เลข AE ที่เลือก (ใช้ prefill ฟอร์มไปแล้วตอน getRecruitsDetails) ต้องส่งไปด้วย
      // ให้ backend auto-insert education/work history จาก Recruit/AE ตอนสร้างพนักงานสำเร็จ
      aeNo: d.ae?.value ?? '',
      checkCode: orgSelete.isCodeAuto ? true : (d.checkCode ?? ''),
      checkUsername: d.checkUsername ?? true,
      orgId: roleId ?? '',
      code: orgSelete.isCodeAuto ? '' : (d.code ?? ''),
      levelId: d.level_id ?? '',
      username: d.username ?? '',
      titleEn: d.title_en?.label ?? '',
      nameEn: d.name_en ?? '',
      surnameEn: d.surname_en ?? '',
      nicknameEn: d.nickname_en ?? '',
      division: d.divisions?.data ?? '',
      department: d.department?.data ?? '',
      teamEn: d.team?.label ?? '',
      positionEn: d.position?.label ?? '',
      phone: d.mobile ?? '',
      phone2: d.in_mobile_offic ?? '', //isNull,
      intraTel: d.in_mobile ?? '',
      email: d.email ?? '',
      lineId: d.id_line ?? '',
      typeId: d.empsTypes?.value ?? '',
      probationId: d.empProbations?.value ?? '',
      reportTo: d.reportby?.value ?? '',
      shiftId: d.shift?.value ?? '',
      travellingId: d.travel?.value ?? '',
      titleTh: d.title_th?.label ?? '',
      nameTh: d.name_th ?? '',
      surnameTh: d.surname_th ?? '',
      nicknameTh: d.nickname_th ?? '',
      teamTh: d.team?.label_th ?? '',
      positionTh: d.position?.label_th ?? '',
      idCard: d.id_card?.replace(/\s/g, '') ?? '',
      birthday: d.birthday ?? '',
      sex: d.sex?.value ?? '',
      nationality: d.nationality?.label ?? '',
      weight: d.weight ?? '', //float
      height: d.height ?? '', //float
      paymentId: d.payment?.value ?? '',
      bank: d.bank?.label ?? '',
      accountNo: d.codeBank ?? '',
      addressCurrent: d.address ?? '',
      subDistCurrent: d.sub_district?.label ?? '',
      distCurrent: d.district?.label ?? '',
      provinceCurrent: d.province?.label,
      postCodeCurrent: d.cr_post_code ?? '',
      addressHome: d.address_first ?? '',
      subDistHome: d.sub_district_first?.label ?? '',
      distHome: d.district_first?.label ?? '',
      provinceHome: d.province_first?.label ?? '',
      postCodeHome: d.post_code_first ?? '',

      startDate: d.startDate ?? '',
      employDate: d.employDate ?? '',
      contractDate: d.contractDate ?? '',
      erRelationId: d.erRelationId?.value ?? '',
      erName: d.erName ?? '',
      erMobilePhone: d.erMobilePhone ?? '',
      erHomePhone: d.erHomePhone ?? '', //isNull,
      erAddress: d.erAddress ?? '',
      erSubDistric: d.erSubDistric?.label ?? '',
      erDistric: d.erDistric?.label ?? '',
      erProvince: d.erProvince?.label ?? '',
      erPostCode: d.erPostCode + '' ?? '',
      personalEmail: d.personalemail ?? '',

      divisionId: d.divisions?.value,
      factionId: d.faction.value,
      faction: d.faction.data, //เพิ่ม ฝ่าย
      departmentId: d.department?.value,
      teamId: d.team.value,
      positionId: d.position.value,
      subDistCurrentId: d.sub_district.value,
      distCurrentId: d.district.value,
      provinceCurrentId: d.province.value,
      subDistHomeId: d.sub_district_first.value,
      distHomeId: d.district_first.value,
      provinceHomeId: d.province_first.value,
      typeIdCard: idPassport,
      // licensePlate: d.licensePlate ?? '',
      licensePlateCar: d.licensePlateCar?.map((_) => _.value).join(','),
      licensePlateMoto: d.licensePlateMoto?.map((_) => _.value).join(','),

      ...(d.supervisor?.value ? { supervisor: d.supervisor.value } : ''),

      otFlatRateId: d.otFlatRate?.value ?? '',
      otShift: d.otShift?.value ?? 0,
      langFeeId: d.languageFee?.value ?? '',
      expFeeId: d.experienceFee?.value ?? '',
      shiftFlatRateId: d.shiftFlatRate?.value ?? '',

      contractStartDate: d.contractStartDate,
      paymentGroupId: d.paymentGroup?.value,

      projectId: d.project?.value,
      locationId: d.location?.value,

      phonePacketId: d.phone?.value,
      orgLevelId: d.orgLevelId?.value ?? '',

      aeNo: d.rc_no ?? ''
    }

    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to save the changes?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: 'var(--comp-badge-color-background-primary)',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        createEmps(body)
      }
    })
  }

  const createEmps = async (body) => {
    try {
      const data = await createEmpsAPI(body)
      setIsSave(false)
      if (!data) return
      if (data.status) {
        SwalCustom({
          title: 'Success!',
          text: 'The information has been successfully saved into the system.',
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          navigate(PIM_EMP)
        })
      } else {
        Error_false(data)
      }
      setIsSave(false)
    } catch (error) {
      setIsSave(false)
      Error_500(error)
    }
  }

  const getRecruitsDetails = async (aeNo) => {
    const orgId = roleId
    const param = {
      orgId,
      aeNo
    }
    try {
      if (aeNo) {
        const data = await getRecruitsDetailsAPI(param)
        if (!data) return
        if (data.status) {
          const res = data.result[0]
          setRecruitsDetail(res)

          setValue('age', res.age)

          setValue('district', res.district)
          setError('district', res.district)

          setValue('district_first', res.district_first)
          setError('district_first', res.district_first)

          setValue('birthday', moment(res.birthday).format('YYYY-MM-DD'))
          setError('birthday', res.birthday)

          setValue('personalemail', res.email)
          setError('personalemail', res.email)

          setValue('height', res.height)
          setError('height', res.height)

          setValue('id_card', res.id_card)
          setError('id_card', res.id_card)

          setValue('id_line', res.id_line)
          setError('id_line', res.id_line)

          setValue('mobile', res.mobile)
          setError('mobile', res.mobile)

          setValue('name_en', res.name_en)
          setError('name_en', res.name_en)

          setValue('name_th', res.name_th)
          setError('name_th', res.name_th)

          setValue('nickname_th', res.nickname)
          setError('nickname_th', res.nickname)

          setValue('nickname_en', res.nickname_en)
          setError('nickname_en', res.nickname_en)

          setValue('rc_no', res.rc_no)
          setError('rc_no', res.rc_no)

          setValue('sex', res.sex)
          setError('sex', res.sex)

          setValue('surname_en', res.surname_en)
          setError('surname_en', res.surname_en)

          setValue('surname_th', res.surname_th)
          setError('surname_th', res.surname_th)

          setValue('title_en', res.title_en)
          setError('title_en', res.title_en)

          setValue('title_th', res.title_th)
          setError('title_th', res.title_th)

          setValue('weight', res.weight)
          setError('weight', res.weight)

          res.ot_flat_rate_id &&
            setValue('otFlatRate', {
              label: res.ot_flat_rate,
              value: res.ot_flat_rate_id
            })

          setValue('otShift', {
            label: res.ot_shift ? 'มี' : 'ไม่มี',
            value: res.ot_shift ? 1 : 0
          })

          res.lang_fee_id &&
            setValue('languageFee', {
              label: res.lang_fee,
              value: res.lang_fee_id
            })

          res.exp_fee_id &&
            setValue('experienceFee', {
              label: res.exp_fee,
              value: res.exp_fee_id
            })

          res.shift_flat_rate_id &&
            setValue('shiftFlatRate', {
              label: res.shift_flat_rate,
              value: res.shift_flat_rate_id
            })
        } else {
          fnReset()
        }
      } else {
        fnReset()
      }
    } catch (error) {
      Error_500(error)
    }
  }

  const fnReset = () => {
    reset()
    setValue('code', `${orgShort}`)
  }
  useEffect(() => {
    const to_year = moment(new Date()).add(543, 'year').format('YY')
    if (optionOrg.length > 0 && roleId) {
      let _short = optionOrg.find((item) => `${item.id}` === `${roleId}`)
      setValue('code', `${_short?.emp_code ?? ''}${to_year}`)
      setOrgShort(`${_short?.emp_code ?? ''}${to_year}`)
    }
  }, [roleId, optionOrg, setValue])

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <NavTitle>
        <TextNavTitle>
          <Link
            to={-1}
            className={`my-auto text-reset text-decoration-none pointer-event`}
          >
            PIM <FaAnglesRight />
            <label className="small fw-medium ms-2">Add Employee</label>
          </Link>
        </TextNavTitle>

        {/* <BtnBack className={' text-muted'} to={PIM_EMP} /> */}
      </NavTitle>
      <NavRoleOrg />
      {orgSelete?.status_id === 1 ? (
        <Row className="mb-3">
          <Col xs={12}>
            <CardCustom>
              <div className="my-auto d-flex justify-content-between p-3">
                <div className="d-flex ">
                  <div style={{ width: '300px' }}>
                    <Controller
                      name={'ae'}
                      control={control}
                      render={({ field: { value = '', onChange } }) => (
                        <InputAutocompleteAE
                          value={value}
                          onChange={(e) => {
                            if (e) {
                              getRecruitsDetails(e.value)
                            } else {
                              getRecruitsDetails()
                            }
                            onChange(e)
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
              <Row>
                <Col
                  xl={12}
                  // md={12} sm={12}
                  className=""
                >
                  <Infomation
                    errors={errors}
                    setError={setError}
                    control={control}
                    setValue={setValue}
                    data={recruitsDetail}
                  />
                </Col>
                <Col xl={12}>
                  <IncomeFrom control={control} errors={errors} />
                </Col>
                <Col
                  xl={12}
                  // md={12} sm={12}
                  className=""
                >
                  <PersonalInformation
                    idPassport={idPassport}
                    setIdPassport={setIdPassport}
                    errors={errors}
                    setError={setError}
                    control={control}
                    setValue={setValue}
                    data={recruitsDetail}
                  />
                </Col>

                <CurrentAddress
                  setError={setError}
                  errors={errors}
                  data={recruitsDetail}
                  control={control}
                  setValue={setValue}
                  getValues={getValues}
                />
                <Col xl={12}>
                  <Emergency
                    errors={errors}
                    setError={setError}
                    control={control}
                    setValue={setValue}
                    data={recruitsDetail}
                  />
                </Col>
                <Col xl={12} className="text-center mb-3">
                  <Button
                    onClick={fnReset}
                    type="button"
                    variant="outline-primary"
                    className="px-4 me-2"
                  >
                    ล้าง
                  </Button>
                  <Button
                    type="submit"
                    onClick={goToTop}
                    disabled={isSave}
                    className="px-4"
                  >
                    {isSave ? 'กำลังบันทึก...' : 'บันทึก'}
                  </Button>
                </Col>
              </Row>
            </CardCustom>
          </Col>
        </Row>
      ) : (
        <CardCustom
          minHeight=""
          className="d-block align-content-center  "
          style={{
            height: 'calc(100vh - 126px)'
          }}
        >
          <div className="mb-4 d-flex align-items-center justify-content-center">
            <div
              className="bg-light d-inline-flex align-items-center justify-content-center rounded-circle"
              style={{ width: '100px', height: '100px' }}
            >
              <HiOutlineShieldCheck size={50} className="text-primary" />
            </div>
          </div>
          <h3 className="text-center">User Not Authenticated</h3>
        </CardCustom>
      )}

      {isSave && <div className="preloader"></div>}
    </Form>
  )
}

export default PimCreate
